import { PrivacySecurityScreen } from '@/modules/profile';
import React from 'react';

export default function PrivacySecurityRoute() {
    return <PrivacySecurityScreen />;
}


